import { Center, Avatar, Heading, Box, IconButton } from '@chakra-ui/react'
import ThreeDots from '../../../../../assets/svg/ThreeDots'
import { IPatient } from '../../../../../types/patients'
import { getPatientAvatar, getPatientInitials } from '../../../../../utils/avatarUtils'

const Header = ({ patientData }: { patientData: IPatient }) => {
  const fullName = `${patientData?.firstName || ''} ${patientData?.lastName || ''}`.trim()

  return (
    <Box
      bgGradient="linear(135deg, brand.purple 0%, purple.500 50%, pink.400 100%)"
      borderRadius="xl"
      p={4}
      mb={4}
    >
      <Center gap={2} justifyContent={'space-between'}>
        <Center>
          <Avatar
            size="md"
            name={getPatientInitials(patientData?.firstName, patientData?.lastName)}
            src={getPatientAvatar(patientData?.id, patientData?.gender)}
            border="3px solid white"
            bg="white"
            color="purple.600"
          />
          <Heading
            fontFamily="Poppins"
            as="p"
            size="md"
            maxW={200}
            textTransform="capitalize"
            ml={3}
            noOfLines={1}
            color="white"
          >
            {fullName}
          </Heading>
        </Center>
        <Box>
          <IconButton
            aria-label="More info"
            icon={<ThreeDots />}
            bg="whiteAlpha.300"
            color="white"
            size="sm"
            _hover={{ bg: 'whiteAlpha.400' }}
          />
        </Box>
      </Center>
    </Box>
  )
}

export default Header